import { render } from "./04_Validate.vue?vue&type=template&id=74bc752c&scoped=true"
import script from "./04_Validate.vue?vue&type=script&lang=js"
export * from "./04_Validate.vue?vue&type=script&lang=js"

import "./04_Validate.vue?vue&type=style&index=0&id=74bc752c&lang=css"
import "./04_Validate.vue?vue&type=style&index=1&id=74bc752c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bc752c"]])

export default __exports__